import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { MarkdownPipe } from "../../../core/pipes/markdown.pipe";
import { StripHtmlPipe } from "../../../core/pipes/remove-html.pipe";
import { RestService } from "../../../core/services/rest.service";
import { shouldRenderMarkdown as contentLooksLikeMarkdown } from "../../../core/utils/markdown.util";
import {
  failCheckDummyData,
  failCheckTableColumns,
} from "../../../core/table-templates/fail-check-table";
import {
  passCheckDummyData,
  passCheckTableColumns,
} from "../../../core/table-templates/pass-check-table";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../common/loading/loading.component";
import { StarRankerComponent } from "../../common/star-ranker/star-ranker.component";

@Component({
  selector: "app-rci-quality-report-modal",
  standalone: true,
  imports: [
    LoadingComponent,
    CommonModule,
    ZorroTableComponent,
    MatExpansionModule,
    StripHtmlPipe,
    MarkdownPipe,
    StarRankerComponent
  ],
  templateUrl: "./rci-quality-report-modal.component.html",
  styleUrl: "./rci-quality-report-modal.component.scss",
})
export class RciQualityReportModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  isActive:boolean = false;

  @Input()
  configs: any = {
    data: {},
    title: "Quality Report",
  };

  isLoading: boolean = false;

  constructor(private restService: RestService) {}

  ngOnInit() {
    this.configs.title= "Quality Report";
    this.configs.fields = [
      {
        name: "Generated Time",
        key: "rciGeneratedTime",
      },
      {
        name: "Report ID",
        key: "qualityReportId",
      },
      {
        name: "User Story ID",
        key: "storyId",
      },
      {
        name: "Title",
        key: "summary",
      },
      {
        name: "Description​",
        key: "description",
      },
      {
        name: "Acceptance Criteria",
        key: "acceptanceCriteria",
      },
      {
        name: "RCI",
        key: "rciScore",
      },
    ];
    this.configs.expandItems= [
      {
        title: "Failed Checks",
        columns: failCheckTableColumns,
        rows: failCheckDummyData,
        isExpand: true,
        headerStyle: {},
        titleStyle: {},
      },
      {
        title: "Passed Checks",
        columns: passCheckTableColumns,
        rows: passCheckDummyData,
        isExpand: true,
      },
    ];
    if(this.configs.isDataReady) {
        this.configs.expandItems[0].rows = this.configs?.data?.failedChecks;
        this.configs.expandItems[1].rows = this.configs?.data?.passedChecks;
    } else {
      this.getReportData();
    }
  }

  getReportData() {
    this.isLoading = true;
    this.restService
      .getRciReport(
        this.configs.projectId,
        this.configs.configId,
        this.configs.reportId
      )
      .subscribe(
        (response: any) => {
          this.isLoading = false;
          this.configs.data = response?.data ?  response?.data : {};
          this.configs.expandItems[0].rows = response?.data?.failedChecks;
          this.configs.expandItems[1].rows = response?.data?.passedChecks;
        },
        (err) => {
          this.isLoading = false;
          console.error(err?.message || "Error while getting report data!");
        }
      );
  }

  shouldRenderMarkdown(value: unknown, mapping?: string): boolean {
    return contentLooksLikeMarkdown(value, mapping);
  }

  isStringList(value: any): boolean {
    return typeof value === 'string' && (value.includes('#') || value.includes('*'));
  }

  // Helper to split the string into an array for the template
  splitStringList(value: string): string[] {
    return value.split(/[#*]/).map(item => item.trim()).filter(item => item.length > 0);
  }
}
